<template>
  <v-menu
    color="var(--color-brand-100)"
    open-delay="600"
    close-delay="750"
    width="100px"
  >
    <template #activator="{ props }">
      <v-btn
        :icon="true"
        v-bind="props"
        variant="text"
        size="small"
        :aria-label="$t('aria.languagechooser')"
        density="compact"
        :slim="true"
        :tile="true"
        class="languagechooser"
      >
        <Component :is="getActiveFlag()" height="20px" width="35px" />
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-for="(item, index) in getLangList()" :key="index">
        <v-row
          align="center"
          valign="start"
          density="comfortable"
          :no-gutters="true"
        >
          <v-col cols="12">
            <v-btn
              :icon="true"
              :aria-label="$t('aria.languagechooser')"
              variant="plain"
              size="small"
              density="compact"
              :slim="true"
              :tile="true"
              @click="setLocale(item.lang)"
            >
              <Component
                :is="getFlagComponent(item.lang)"
                height="20px"
                width="35px"
              />
            </v-btn>
          </v-col>
          <v-col cols="12">
            <span class="langname">{{ item.label }}</span>
          </v-col>
        </v-row>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import adminStore from '@/stores/adminstore'
import { mapActions, mapState } from 'pinia'
import dayjs from '@/plugins/dayjs.js'

import csFlag from '@/assets/svgs/flags/csFlag.vue'
import daFlag from '@/assets/svgs/flags/daFlag.vue'
import deFlag from '@/assets/svgs/flags/deFlag.vue'
import enFlag from '@/assets/svgs/flags/enFlag.vue'
import esFlag from '@/assets/svgs/flags/esFlag.vue'
import fiFlag from '@/assets/svgs/flags/fiFlag.vue'
import frFlag from '@/assets/svgs/flags/frFlag.vue'
import itFlag from '@/assets/svgs/flags/itFlag.vue'
import ltFlag from '@/assets/svgs/flags/ltFlag.vue'
import lvFlag from '@/assets/svgs/flags/lvFlag.vue'
import nbFlag from '@/assets/svgs/flags/nbFlag.vue'
import nlFlag from '@/assets/svgs/flags/nlFlag.vue'
import plFlag from '@/assets/svgs/flags/plFlag.vue'
import ptFlag from '@/assets/svgs/flags/ptFlag.vue'
import roFlag from '@/assets/svgs/flags/roFlag.vue'
import seFlag from '@/assets/svgs/flags/seFlag.vue'
import svFlag from '@/assets/svgs/flags/svFlag.vue'
import trFlag from '@/assets/svgs/flags/trFlag.vue'

export default {
  name: 'LanguageChooser',
  // props: ['auth', 'authenticated'],
  data() {
    return {
      flagComponentsMap: new Map()
    }
  },
  mounted() {
    const localeLang = localStorage.getItem('lang') || this.$i18n.locale
    console.info('Mounted lang (%s) (%s)', this.$i18n.locale, localeLang)
    if (localeLang) {
      this.$root.$i18n.locale = localeLang
      // const webLang = get3DigitLangCode(this.$i18n.locale)
      // console.log('=== WEB LANG === (%o)', webLang)
      this.setLang(localeLang) // was webLang
      this.$date.locale(this.$root.$i18n.locale)
    } else {
      // console.log('Mounted lang (%s)', this.$i18n.locale)
      // const webLang = get3DigitLangCode(this.$i18n.locale)
      // console.log('=== WEB LANG === (%o)', webLang)
      localStorage.setItem('lang', this.$i18n.locale)
      this.setLang(localeLang) // was webLang
      this.$date.locale(this.$root.$i18n.locale)
    }
    const countryList = this.getLanguageList() || []
    for (let i = 0; i < countryList.length; i++) {
      const item = countryList[i]
      this.flagComponentsMap.set(item.lang, item.flag)
    }
  },
  beforeMount() {
    const localeLang = localStorage.getItem('lang') || this.$i18n.locale
    this.$i18n.locale = localeLang
    // console.log(this.$i18n.locale)
    let webLang = this.$i18n.locale // get3DigitLangCode(this.$i18n.locale)
    this.setLang(webLang)
    localStorage.setItem('lang', webLang)
    this.$date.locale(this.$root.$i18n.locale)
  },
  methods: {
    ...mapActions(adminStore, ['setLang']),
    ...mapState(adminStore, ['getLanguageList']),
    setLocale(lang) {
      let locale = this.$root.$i18n.locale
      console.log('setLocale old:(%s) new:(%s)', locale, lang)
      this.$root.$i18n.locale = lang
      this.$i18n.locale = lang
      this.$vuetify.locale.locale = lang
      this.$date.locale(this.$root.$i18n.locale)
      let webLang = this.$root.$i18n.locale // get3DigitLangCode('en')
      // console.log('=== WEB LANG === (%o)', webLang)
      this.setLang(webLang)
      localStorage.setItem('lang', webLang)
    },
    getFlagComponent(lang) {
      // console.log('getFalg compnentn fot called (%s)', lang)
      if (this.flagComponentsMap.has(lang)) {
        //  console.log('HAS component (%s)', this.flagComponentsMap.get(lang))
        return this.getActiveFlagComponent(lang)
      } else {
        return enFlag
      }
    },
    getActiveFlag() {
      const locale = this.$root.$i18n.locale
      return this.getActiveFlagComponent(locale)
    },
    getActiveFlagComponent(lang) {
      // console.log('getActiveFlagComponent (%s)', lang)
      switch (lang) {
        case 'nb':
          return nbFlag
        case 'nn':
          return nbFlag
        case 'en':
          return enFlag
        case 'fr':
          return frFlag
        case 'de':
          return deFlag
        case 'es':
          return esFlag
        case 'sv':
          return svFlag
        case 'ro':
          return roFlag
        case 'it':
          return itFlag
        case 'cs':
          return csFlag
        case 'pt':
          return ptFlag
        case 'se':
          return seFlag
        case 'da':
          return daFlag
        case 'nl':
          return nlFlag
        case 'fi':
          return fiFlag
        case 'pl':
          return plFlag
        case 'lv':
          return lvFlag
        case 'lt':
          return ltFlag
        case 'tr':
          return trFlag
        default:
          return enFlag
      }
    },
    getLangList() {
      const locale = this.$root.$i18n.locale
      const langList = []
      const countryList = this.getLanguageList()
      for (let i = 0; i < countryList.length; i++) {
        const item = countryList[i]
        if (item.lang !== locale) {
          langList.push(item)
        }
      }
      return langList
    },
    setLanguage(lang) {
      console.log('SetLanguage: ' + lang)
      this.$i18n.locale = lang
      dayjs.locale(lang)
      localStorage.setItem('hyplang', lang)
      let webLang = this.$i18n.locale // get3DigitLangCode(this.$i18n.locale)
      // console.log('=== WEB LANG === (%o)', webLang)
      this.setLang(webLang)
      localStorage.setItem('lang', webLang)
    }
  }
}
</script>

<style lang="css">
.langname {
  font-size: 0.9rem;
  color: black;
  font-weight: 500;
  text-transform: capitalize;
}

.languagechooser {
  margin-left: 1vw;
}
</style>
